import type { TFunction } from 'i18next';
import type { FacilitySignal } from '../../../services/api/facilityMetricsService';

export function getActionCopy(signal: FacilitySignal, t: TFunction): string {
    const remaining =
        signal.target != null ? signal.target - signal.current : 0;

    switch (signal.key) {
        // Onboarding
        case 'usersAdded':
            return remaining > 0
                ? t('facilities.onboarding.actionCopy.addMoreUsers', { remaining })
                : t('facilities.onboarding.actionCopy.allSlotsFilled');
        case 'rolesAssigned':
            return remaining > 0
                ? t('facilities.onboarding.actionCopy.assignRoles', { remaining })
                : t('facilities.onboarding.actionCopy.allRolesAssigned');
        case 'scannersAdded':
            return signal.current >= 1
                ? t('facilities.onboarding.actionCopy.scannerAdded')
                : t('facilities.onboarding.actionCopy.addFirstScanner');
        case 'policiesUploaded':
            return signal.current >= 1
                ? t('facilities.onboarding.actionCopy.policyUploaded')
                : t('facilities.onboarding.actionCopy.addFirstPolicy');

        // Trial
        case 'usersLoggedInPercent':
            return remaining > 0
                ? t('facilities.onboarding.actionCopy.usersNeedSignIn', { remaining })
                : t('facilities.onboarding.actionCopy.allUsersSignedIn');
        case 'usersSearchedPercent':
            return remaining > 0
                ? t('facilities.onboarding.actionCopy.usersHaventSearched', { remaining })
                : t('facilities.onboarding.actionCopy.allUsersSearched');
        case 'averageSearchesPerUser':
            return t('facilities.onboarding.actionCopy.averageSearches', { current: signal.current });
        case 'multipleActiveUsers':
            return remaining > 0
                ? t('facilities.onboarding.actionCopy.getMoreActiveUsers', { remaining })
                : t('facilities.onboarding.actionCopy.multipleUsersActive');
        case 'cptReportsCreated':
            return signal.current === 0
                ? t('facilities.onboarding.actionCopy.createFirstCptReport')
                : t('facilities.onboarding.actionCopy.cptReportsCreated', { current: signal.current });
        default:
            return '';
    }
}

export function getSignalCount(signal: FacilitySignal): string {
    if (signal.target == null || signal.key === 'policiesUploaded' || signal.key === 'scannersAdded') {
        return `${signal.current}`;
    }

    return `${signal.current} / ${signal.target}`;
}
